import React, { Component, Fragment } from 'react';
import { withRouter } from '../../WithRouterHOC';
import BuyModal from '../BuyModal/BuyModal';
import Util from '../../../script/util';
import './ListItem.scss';
import PrettyNum from '../../prettyNum/PrettyNum';

class ListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // 展示弹窗
  OpenByModal = () => {
    const { items } = this.props;
    this.buyModalEle.showModal(items);
  };

  // 展示图片
  renderPropImg = () => {
    const { items } = this.props;
    let className = 'mall-center';

    const beautifulNo = items.beautifulNo || false;
    const backgroundImage =
      items.backgroundPic && !beautifulNo
        ? { backgroundImage: `url(${Util.transImgUrl(items.backgroundPic)})` }
        : {};
    return (
      <div className={className}>
        <div className="prop-box" style={backgroundImage}>
          {!!beautifulNo ? (
            <div className="beautiful-no">
              <PrettyNum isBright num={beautifulNo} />
            </div>
          ) : (
            <img src={Util.transImgUrl(items.titlePic)} alt={items.goodsName} />
          )}
        </div>
      </div>
    );
  };

  render() {
    const {
      items,
      base: { userLevel },
      isName,
      changeCenterTab,
    } = this.props;
    return (
      <Fragment>
        <div className="mall-child" onClick={this.OpenByModal}>
          <div className="mall-top">
            {items.wealthLevel ? (
              <div className="type-level">
                {userLevel[items.wealthLevel]}以上专属
              </div>
            ) : null}
            {items.isBuy ? <i className="icon-lock" /> : null}
            {this.renderPropImg()}
            <div className="masking" />
          </div>
          <div className="mall-bottom">
            <p className={`mall-grade ${isName ? '' : 'alone'}`}>
              {items.goodsName}
            </p>
            {isName ? <p className="mall-name">{items.propTypeName}</p> : null}
          </div>
          <div className="hover" />
        </div>

        <BuyModal
          wrappedComponentRef={(el) => (this.buyModalEle = el)}
          base={this.props.base}
          changeCenterTab={changeCenterTab}
        />
      </Fragment>
    );
  }
}

export default withRouter(ListItem, { withRef: true });

ListItem.defaultProps = {
  isName: false,
};
